const INR = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  maximumFractionDigits: 0,
});

const INR_COMPACT = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  notation: 'compact',
  maximumFractionDigits: 1,
});

/** Format a number as Indian Rupees, e.g. ₹7,999 */
export function formatINR(amount: number | string | null | undefined): string {
  const value = Number(amount ?? 0);
  if (!Number.isFinite(value)) return '₹0';
  return INR.format(value);
}

/** Compact INR for KPI cards, e.g. ₹7.9K / ₹2.5L */
export function formatINRCompact(amount: number | string | null | undefined): string {
  const value = Number(amount ?? 0);
  if (!Number.isFinite(value)) return '₹0';
  return INR_COMPACT.format(value).replace('T', 'K');
}
